module.exports = __webpack_public_path__ + "eb248ddf0a3d04e083343382daf7b08c.svg";